export const experienceData = [
    {
        id: 1,
        company: 'Bharat Heavy Electricals Limited, Haridwar',
        jobtitle: 'Intern',
        startYear: '04/2021',
        endYear: '05/2021'
    },
    {
        id: 2,
        company: 'Muskan Foundation, Mumbai',
        jobtitle: 'Volunteer',
        startYear: '05/2019',
        endYear: '07/2021'
    }
]